import React, { useState } from "react";

import HttpManager from "../../../../services/HttpManager";
import { EventAttendeeDTO, EventDetailDTO } from "../../../../models/EventDTO";
import S from "./strings";
import BajaPanel from "./bajaPanel";
import { Chip, Modal, blobErrorText, cuando, dinero, errorText, guardarBlob, slug, useRolDinero } from "./comun";

/** «Más › Otros Invitados»: especiales, externos e invitados sin graduada (no van en la lista principal). */
const OtrosInvitados: React.FC<{ campusId: number; evento: EventDetailDTO; ids: number[]; onClose: () => void; reload: () => void; notify: (t: string, ok?: boolean) => void }> = ({ campusId, evento, ids, onClose, reload, notify }) => {
	const http = HttpManager.getInstance();
	const rolDinero = useRolDinero(campusId);
	const [baja, setBaja] = useState<EventAttendeeDTO | null>(null);
	const lista = evento.attendees.filter(a => ids.includes(a.id));
	const soloLectura = evento.isHistoric || evento.status === "anulado";
	const m = (v: number) => dinero(evento.currency, v);
	const pdf = (a: EventAttendeeDTO) => http.eventsService.invitationPdf(campusId, a.id).then(r => guardarBlob(r.data, `Invitacion_${slug(a.name)}.pdf`)).catch(async e => notify(await blobErrorText(e), false));
	const pagoManual = (a: EventAttendeeDTO, paid: boolean) => http.eventsService.updateAttendee(campusId, { attendeeId: a.id, paid }).then(reload).catch(e => notify(errorText(e), false));
	const pago = (a: EventAttendeeDTO) => {
		if (a.charge && a.charge.statusId !== 4) return a.paid ? <span className="wevSub">{m(a.charge.total)}</span> : <Chip tono="oro">{S.falta(m(a.charge.pending))}</Chip>;
		if (a.kind === "externo" && a.price && !soloLectura && rolDinero) {
			return <label className="wev-check"><input type="checkbox" checked={a.paid} onChange={e => pagoManual(a, e.target.checked)} /><span className={a.paid ? "" : "wevOro"}>{a.paid ? S.pagado : S.falta(m(a.price))}</span></label>;
		}
		if (a.kind === "externo" && a.price) return a.paid ? <span className="wevSub">{S.pagado}</span> : <Chip tono="oro">{S.falta(m(a.price))}</Chip>;
		return <span className="wevSub">{a.paid ? S.pagado : S.sinCobro}</span>;
	};
	return (
		<Modal title={S.otrosInvitados(lista.length)} onClose={onClose} ancho={640}>
			{baja ? <BajaPanel campusId={campusId} evento={evento} asistente={baja} onVolver={() => setBaja(null)} onDone={(t) => { setBaja(null); notify(t); reload(); }} /> : (
				<div>
					{lista.map(a => (
						<div key={a.id} className="wevRenglon">
							<div className="izq"><b>{a.name}</b><Chip>{a.kindLabel}</Chip>{a.hostName ? <span className="wevSub">{S.invitaA(a.hostName)}</span> : null}
								{a.checkedInAt ? <span className="wevSub">{S.colEntrada} {cuando(a.checkedInAt, true)}</span> : null}</div>
							<div className="der">{pago(a)}
								<button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => pdf(a)}>{S.pdf}</button>
								{soloLectura ? null : <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => setBaja(a)}>{S.baja}</button>}
							</div>
						</div>
					))}
				</div>
			)}
		</Modal>
	);
};

export default OtrosInvitados;
